import { Component, inject } from '@angular/core';
import { UserUiService } from '../shared';
import { UserContextService } from '../common';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-homepage',
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss'
})
export class HomepageComponent {
  private userUiService = inject(UserUiService);
  private router = inject(Router);

  ngOnInit(): void {
    if (UserContextService.isAuthenticated()) {
      this.router.navigate([this.userUiService.getInitialPage()]);
    } else {
      this.router.navigate(['auth/login']);
    }
  }
}
